import i18n from '@/i18n'

function loadStoredFilters(toolName) {
  if (!toolName) return null;
  const filtersStr = localStorage.getItem(`${toolName} filters`);
  if (!filtersStr) return null;
  try {
    return JSON.parse(filtersStr);
  } catch (e) {
    console.error('Error parsing filters:', e);
    return null;
  }
}

function matchesSearch(report, search) {
  if (!search || !String(search).trim()) return true;

  const q = String(search).trim().toLowerCase();
  if (String(report.row_number ?? '').toLowerCase().includes(q)) return true;

  const template = String(report.template ?? '')
    .replace(/_/g, ' ')
    .toLowerCase();
  if (template.includes(q)) return true;

  return Object.values(report.fields || {}).some((value) =>
    String(value ?? '')
      .toLowerCase()
      .includes(q)
  );
}

function matchesFilters(report, filters, currentToolFields = []) {
  if (!filters || typeof filters !== 'object') return true;

  if (filters.startDate && String(filters.startDate).trim() !== '') {
    const reportDate = new Date(report.created_at);
    const startDate = new Date(filters.startDate);
    if (reportDate < startDate) return false;
  }

  if (filters.endDate && String(filters.endDate).trim() !== '') {
    const reportDate = new Date(report.created_at);
    const endDate = new Date(filters.endDate);
    endDate.setHours(23, 59, 59, 999);
    if (reportDate > endDate) return false;
  }

  if (filters.comment && String(filters.comment).trim() !== '') {
    const reportComment = report.comment || '';
    if (!reportComment.toLowerCase().includes(String(filters.comment).toLowerCase())) {
      return false;
    }
  }

  return currentToolFields.every((field) => {
    const fieldName = field.name;
    if (filters[fieldName] && String(filters[fieldName]).trim() !== '') {
      return report.fields?.[fieldName] === filters[fieldName];
    }
    return true;
  });
}

/**
 * Whether a report should be inserted into the current list view.
 * Prefer explicit filters/search from the RTK query args; fall back to
 * localStorage filters for the active tool when those are omitted.
 */
export const shouldAddReportBasedOnFilters = (
  updatedReport,
  toolName,
  currentToolFields = [],
  { filters, search } = {}
) => {
  if (!matchesSearch(updatedReport, search)) return false;

  const effectiveFilters =
    filters !== undefined ? filters : loadStoredFilters(toolName);

  return matchesFilters(updatedReport, effectiveFilters, currentToolFields);
};

export function getEnglishTypeTranslation(text) {
  const currentLang = i18n.language;

  if (currentLang === 'en') {
    return text;
  }

  const currentLangTypes = i18n.getDataByLanguage(currentLang)?.translation.reports.table.types;
  if (!currentLangTypes || typeof currentLangTypes !== 'object') {
    return text;
  }

  const enTypes = i18n.getDataByLanguage('en')?.translation.reports.table.types;
  if (!enTypes) {
    return text;
  }

  for (const typeKey in currentLangTypes) {
    if (
      currentLangTypes[typeKey]?.toLowerCase()?.includes(text?.toLowerCase()) ||
      text?.toLowerCase()?.includes(currentLangTypes[typeKey]?.toLowerCase())
    ) {
      return enTypes[typeKey] || text;
    }
  }

  return text;
}
